import { render, staticRenderFns } from "./ProjectManagement.vue?vue&type=template&id=6bdb1410"
import script from "./ProjectManagement.vue?vue&type=script&lang=ts"
export * from "./ProjectManagement.vue?vue&type=script&lang=ts"
import style0 from "./ProjectManagement.vue?vue&type=style&index=0&id=6bdb1410&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports